import { TherapistAction } from '../../../src/redux/actions/constant';

export const getAllTherapistTaskAction = (payload: any) => {
  return {
    type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
    payload,
  };
};

export const updateTimeBasisAction = (payload: any) => {
  return {
    type: TherapistAction.UPDATE_TIME_BASIS_REQUEST,
    payload,
  };
};

export const resetTimeBasisAction = () => {
  return {
    type: TherapistAction.UPDATE_TIME_BASIS_RESET,
  };
};
